import React from 'react';

function PrimaryButton({ type, value, loading, bgColor = "bg-primary", onClick, disabled = false }) {
  const baseClasses = "px-4 py-2 text-white rounded hover:bg-secondary ";
  const disabledClasses = disabled ? "opacity-60 cursor-not-allowed " : "";

  return (
    <button
      type={type}
      className={baseClasses + disabledClasses + bgColor}
      onClick={onClick}
      disabled={disabled}
    >
      <div className='flex items-center'>
        {loading ? (
          <div className="animate-spin rounded-full border-t-2 border-b-2 border-white h-4 w-4 mr-2"></div>
        ) : null}
        {value}
      </div>
    </button>
  );
}

export default PrimaryButton;